module.exports = __webpack_public_path__ + "img/synx-domain-logo.1b24b7c2.webp";